// extracted by mini-css-extract-plugin
export default {"CompanyContainer":"CompanyBubble_CompanyContainer__FPHnK","CompanyContainerLink":"CompanyBubble_CompanyContainerLink__M-Ie-"};